export const ITEMS_LIST = [
  {
    active: true,
    email: 'type1_active_5',
    id: '1',
    status: 'success',
    type: 'type1',
    unread: 5,
  },
  {
    email: 'type1_reconnect_noactive_0',
    id: '2',
    status: 'need_reconnect',
    type: 'type1',
    unread: 0,
  },
  {
    active: true,
    email: 'type2_active_15',
    id: '3',
    status: 'success',
    type: 'type2',
    unread: 15,
  },
  {
    active: false,
    email: 'type3_noactive_0',
    id: '4',
    status: 'success',
    type: 'type3',
  },
  {
    active: false,
    email: 'type2_noactive_0',
    id: '5',
    status: 'success',
    type: 'type2',
  },
  {
    active: false,
    email: 'type2_noactive_0',
    id: '6',
    status: 'success',
    type: 'type2',
  },
  {
    active: false,
    email: 'type2_noactive_0',
    id: '7',
    status: 'success',
    type: 'type2',
  },
  {
    active: false,
    email: 'type2_noactive_0@email.com',
    id: '8',
    status: 'success',
    type: 'type2',
    unread: 2,
  },
]

export const FOLDERS = [
  { name: 'inbox', title: 'Table.InboxSubmenuKey' },
  { name: 'sent', title: 'Table.SentSubmenuKey' },
  { name: 'important', title: 'Table.ImportantSubmenuKey' },
  { name: 'archive', title: 'Table.ArchiveSubmenuKey' },
  { name: 'trash', title: 'Table.TrashSubmenuKey' },
]
